exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-create-list-inspection {\n  padding: 2px;\n  width: 100px;\n  height: 30px;\n  text-align: center;\n  margin-top: 15px;\n  margin-right: 17px;\n}\n", ""]);

